import * as Dialog from '@radix-ui/react-dialog'
import { ReactNode } from 'react'
import { webchatClasses } from '../../styles/classes'

export function Modal({
  open,
  onOpenChange,
  children,
}: {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  children: ReactNode
}) {
  const { modal } = webchatClasses

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Overlay {...modal?.overlay} />
      {children}
    </Dialog.Root>
  )
}

function ModalContent({
  title,
  description,
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  children,
}: {
  title?: string
  description?: string
  onConfirm?: () => void
  onCancel?: () => void
  confirmButtonText?: string
  cancelButtonText?: string
  children: ReactNode
}) {
  const { modal } = webchatClasses

  return (
    <>
      <Dialog.Content {...modal.dialog.container}>
        <Dialog.Title {...modal.dialog.title}>{title}</Dialog.Title>
        <Dialog.Description {...modal.dialog.description}>{description}</Dialog.Description>
        <div {...modal.dialog.content.container}>{children}</div>
        <div {...modal.dialog.button.container}>
          {confirmButtonText && (
            <button {...modal.dialog.button.confirm} type="button" onClick={onConfirm}>
              {confirmButtonText}
            </button>
          )}
          {cancelButtonText && (
            <button {...modal.dialog.button.cancel} type="button" onClick={onCancel}>
              {cancelButtonText}
            </button>
          )}
        </div>
      </Dialog.Content>
    </>
  )
}

Modal.Button = Dialog.Trigger
Modal.Close = Dialog.Close
Modal.Content = ModalContent
